export function generateContactName(contactDetails: any){

    let contactName: string = "";

    if(contactDetails){
        contactName = contactDetails?.firstName ? contactDetails?.firstName?.trim() : contactName;
        contactName = contactDetails.middleName ? contactName.concat(" "+contactDetails.middleName?.trim()) : contactName;
        contactName = contactDetails.lastName ? contactName.concat(" "+contactDetails.lastName?.trim()) : contactName;
    }

    return contactName?.trim();
}
